export default __webpack_public_path__ + "static/media/Car_white.55bb6559.svg";